export const AUTH_SESSION_KEYS = {
  OTP_TOKEN: "auth.otp_token",
  REG_SESSION_ID: "auth.reg_session_id",
  REG_NPWP: "auth.reg_npwp",
  REG_COMPANY: "auth.reg_company"
} as const;
